var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGithubblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0391 24.8672H24.9609C21.8594 24.8672 19.1276 24.0781 17.5104 25.5651C17.071 25.9555 16.721 26.4361 16.4842 26.974C16.2473 27.5119 16.1293 28.0946 16.138 28.6823C16.138 33.5052 20 34.099 24.9635 34.099H25.0391C30 34.099 33.8646 33.5026 33.8646 28.6823C33.8646 27.5286 33.4583 26.4531 32.4922 25.5651C30.8724 24.0781 28.1406 24.8672 25.0391 24.8672ZM20.8151 31.4583C19.8698 31.4583 19.1068 30.3958 19.1068 29.0885C19.1068 27.7812 19.8698 26.724 20.8151 26.724C21.7604 26.724 22.526 27.7812 22.526 29.0885C22.5286 30.3958 21.763 31.4583 20.8151 31.4583ZM29.1823 31.4583C28.237 31.4583 27.4714 30.3958 27.4714 29.0885C27.4714 27.7812 28.237 26.724 29.1823 26.724C30.125 26.724 30.8906 27.7812 30.8906 29.0885C30.8932 30.3958 30.1276 31.4583 29.1823 31.4583ZM25 0C11.1927 0 0 11.1927 0 25C0 38.8073 11.1927 50 25 50C38.8073 50 50 38.8073 50 25C50 11.1927 38.8073 0 25 0ZM27.2812 35.2578C26.8333 35.2578 25.9427 35.2578 25 35.263C24.0573 35.2578 23.1667 35.2578 22.7187 35.2578C20.7396 35.2578 12.8958 35.1042 12.8958 25.651C12.8958 23.4792 13.6406 21.888 14.862 20.5599C14.6693 20.0807 14.6589 17.3516 15.6953 14.737C15.6953 14.737 18.0807 14.9974 21.6875 17.474C22.4401 17.263 23.7214 17.1562 25 17.1562C26.2786 17.1562 27.5573 17.263 28.3151 17.4714C31.9219 14.9948 34.3073 14.7344 34.3073 14.7344C35.3438 17.349 35.3359 20.0807 35.1406 20.5573C36.362 21.8854 37.1068 23.4766 37.1068 25.6484C37.1042 35.1068 29.2604 35.2578 27.2812 35.2578Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubblack);
export default __webpack_public_path__ + "static/media/githubblack.4fbd5102d119a44c148e385b7fabec36.svg";
export { ForwardRef as ReactComponent };